{
  "aiGeneratedAnswer": "AI gegenereerd antwoord",
  "allCategories": "Alle categorieën",
  "appliedFiltersToCurrentSearch": "Toegepaste filters op de huidige zoekopdracht",
  "apply": "Toepassen",
  "applyFilters": "Filters toepassen",
  "autocompleteOptionsFound_one": "{{count}}{{label}} automatisch aanvulsuggestie gevonden.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} automatisch aanvulsuggesties gevonden.",
  "autocompleteSuggestion": "automatisch aanvultip: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} automatisch aanvultip gevonden.",
  "autocompleteSuggestionsFound_other": "{{count}} automatisch aanvultips gevonden.",
  "basedOnYourDevice": " (gebaseerd op je apparaat)",
  "basedOnYourInternetAddress": " (gebaseerd op je internetadres)",
  "categoriesText_one": "De volgende categorie leverde resultaten op voor - <strong>{{query}}</strong>",
  "categoriesText_other": "De volgende categorieën leverden resultaten op voor - <strong>{{query}}</strong>",
  "clearAll": "Alles wissen",
  "clearMinAndMax": "Min en max wissen",
  "clearTheRangeToSelectOptions": "Wis het bereik om opties te selecteren.",
  "clearTheSearchBar": "Zoekbalk wissen",
  "conductASearch": "Een zoekopdracht uitvoeren",
  "currentLocation": "Huidige locatie",
  "didYouMean": "Bedoelde je <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Wanneer automatische aanvulresultaten beschikbaar zijn, gebruik de pijltjestoetsen omhoog en omlaag om te navigeren en Enter om te selecteren.",
  "feedback": "Feedback",
  "invalidRange": "Ongeldig bereik",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Navigeer naar de volgende resultatenpagina",
  "navigateToThePreviousResultsPage": "Navigeer naar de vorige resultatenpagina",
  "noAutocompleteOptionsFound": "0 automatisch aanvulopties gevonden.",
  "noAutocompleteSuggestionsFound": "0 automatisch aanvultips gevonden.",
  "noResultsFoundIn": "Geen resultaten gevonden in {{currentVerticalLabel}}.",
  "pagination": "Paginering",
  "readMoreAbout": "Lees meer over <a>{{name}}</a>",
  "recentSearch": "recente zoekopdracht: {{query}}",
  "recentSearchesFound_one": "{{count}} recente zoekopdracht gevonden.",
  "recentSearchesFound_other": "{{count}} recente zoekopdrachten gevonden.",
  "removeFilter": "Filter „{{displayName}}“ verwijderen",
  "resultPreview": "resultaatvoorbeeld: {{value}}",
  "resultPreviewsFound_one": "{{count}} resultaatvoorbeeld gevonden.",
  "resultPreviewsFound_other": "{{count}} resultaatvoorbeelden gevonden.",
  "resultsCountText_one": "{{count}} resultaat",
  "resultsCountText_other": "{{count}} resultaten",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} van {{resultsCount}} resultaten",
  "searchHere": "Hier zoeken…",
  "showLess": "Minder weergeven",
  "showMore": "Meer weergeven",
  "showingAllInstead": "Toont in plaats daarvan alle {{currentVerticalLabel}}.",
  "sources_one": "Bron",
  "sources_other": "Bronnen ({{count}})",
  "submitSearch": "Zoekopdracht versturen",
  "suggestionResultsCount_one": "{{label}} - {{count}} resultaat",
  "suggestionResultsCount_other": "{{label}} - {{count}} resultaten",
  "thankYouForYourFeedback": "Bedankt voor je feedback!",
  "thisAnsweredMyQuestion": "Dit beantwoordde mijn vraag",
  "thisDidNotAnswerMyQuestion": "Dit beantwoordde mijn vraag niet",
  "unselectAnOptionToEnterInARange": "Deselecteer een optie om een bereik in te voeren.",
  "updateYourLocation": "Werk je locatie bij",
  "useCurrentLocation": "Gebruik huidige locatie",
  "useMyLocation": "Gebruik mijn locatie",
  "viewAll": "Bekijk alles",
  "viewDetails": "Bekijk details"
}
